/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

export enum PayoutCommonTicketV1Priority {
    PRIORITY_UNSPECIFIED = 'PRIORITY_UNSPECIFIED',
    PRIORITY_HIGH = 'PRIORITY_HIGH',
    PRIORITY_MEDIUM = 'PRIORITY_MEDIUM',
    PRIORITY_LOW = 'PRIORITY_LOW',
}
